var level = require('level-js');

var Cache = require('./Cache');

module.exports = Cache(level);